import { Autocomplete, AutocompleteProps } from '@mantine/core';
import styles from '../styles/Input.module.css';
import { SearchIcon } from '../../icons/SearchIcon';

export const Search = (props: AutocompleteProps) => {
    return (
        <Autocomplete
            classNames={{
                input: styles.input,
                label: styles.label,
                option: styles.option,
                description: styles.description,
            }}
            rightSection={<SearchIcon {...(props.disabled && { fill: 'var(--input-disabled-color)' })} />}
            {...props}
        />
    );
};
